import React from 'react';
import Navbar from '../components/Navbar';
import TechnologyHero from '../components/technology/TechnologyHero';
import TechnologyProblem from '../components/technology/TechnologyProblem';
import WhyTraainTechnology from '../components/technology/WhyTraainTechnology';
import TechnologyBenefits from '../components/technology/TechnologyBenefits';
import TechnologyEcosystem from '../components/technology/TechnologyEcosystem';
import TechnologyResults from '../components/technology/TechnologyResults';
import TechnologyCTA from '../components/technology/TechnologyCTA';
import Footer from '../components/Footer';

const TechnologyPage = () => {
  return (
    <div className="min-h-screen bg-gray-950 text-white">
      {/* Animated Background */}
      <div className="fixed inset-0 z-0">
        <div className="absolute inset-0 bg-gradient-to-br from-blue-950 via-gray-900 to-indigo-950 animate-gradient" />
        <div className="absolute inset-0 opacity-20">
          <div className="absolute top-0 left-0 w-96 h-96 bg-blue-500 rounded-full filter blur-3xl animate-blob" />
          <div className="absolute top-0 right-0 w-96 h-96 bg-indigo-500 rounded-full filter blur-3xl animate-blob animation-delay-2000" />
          <div className="absolute bottom-0 left-1/2 w-96 h-96 bg-cyan-500 rounded-full filter blur-3xl animate-blob animation-delay-4000" />
        </div>
      </div>

      {/* Content */}
      <div className="relative z-10">
        <Navbar />
        <TechnologyHero />
        <TechnologyProblem />
        <WhyTraainTechnology />
        <TechnologyBenefits />
        <TechnologyEcosystem />
        <TechnologyResults />
        <TechnologyCTA />
        <Footer />
      </div>
    </div>
  );
};

export default TechnologyPage;
